import '../css/aurus.scss'; 
import Aurus from '../components/Aurus/Aurus';
import CategoryList from '../components/Aurus/CategoryList';
import ProductGrid from '../components/Aurus/ProductGrid';
import CollectionList from '../components/Aurus/CollectionList';
import AurusBanner from '../components/Aurus/AurusBanner';
import AurusImageBlock from '../components/Aurus/AurusImageBlock';
import ProductGridWithBanner from '../components/Aurus/ProductGridWithBanner';
import UmniyDom from '../components/Aurus/UmniyDom';


const AurusPage = () => {
  return (
    <div className="aurus aurus--dark">
      

      <Aurus />
      <CategoryList />
      <AurusBanner />
      <AurusImageBlock />
      <ProductGrid />
      <CollectionList />
      <ProductGridWithBanner />
      <UmniyDom />
      <div className="aurus-transition-gradient" />

    </div>
  );
};

export default AurusPage;
